"use client";

import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ThemeProviderProps } from "next-themes";
import { FEATURES } from "@/config";

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  // When theme switch is disabled, force light theme
  const forcedTheme = FEATURES.themeSwitchEnabled ? undefined : "light";

  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={FEATURES.themeSwitchEnabled}
      forcedTheme={forcedTheme}
      disableTransitionOnChange={false}
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
